'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './news-archive.routes';

export class NewsArchiveComponent {
  constructor(NewsService, Auth, $state, Config) {
    'ngInject';

    this.currentPage = 1;
    this.itemsPerPage = Config.getPagination("newsArchive");

    this.isAdmin = Auth.isAdminSync;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, 'News Archive');

    this.newsByRange = {
      "Q1-2017": [],
      "Q2-2017": [],
      "Q3-2017": [],
      "Q4-2017": [],

      "Q1-2016": [],
      "Q2-2016": [],
      "Q3-2016": [],
      "Q4-2016": [],

      "2015": [],
      "2014": [],
      "2013": [],
      "older": []
    };

    this.news = [];

    NewsService.query(data => {
      data.forEach(news => {

        if (moment(news.meta.creationDate).isBetween('2017-01-01', '2017-03-31')) {
          this.newsByRange["Q1-2017"].push(news);
        }
        else if (moment(news.meta.creationDate).isBetween('2017-04-01', '2017-06-30')) {
          this.newsByRange["Q2-2017"].push(news);
        }
        else if (moment(news.meta.creationDate).isBetween('2017-07-01', '2017-09-30')) {
          this.newsByRange["Q3-2017"].push(news);
        }
        else if (moment(news.meta.creationDate).isBetween('2017-10-01', '2017-12-31')) {
          this.newsByRange["Q4-2017"].push(news);
        }
      })
    });

  }

  switchNewsByRange(newsRange) {
    this.news = this.newsByRange[newsRange];
  }

  countNewsByRange(newsRange) {
    return this.newsByRange[newsRange].length;
  }
}

export default angular.module('conduuApp.newsArchive', [uiRouter])
  .config(routes)
  .component('newsArchive', {
    template: require('./news-archive.html'),
    controller: NewsArchiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/news/archive/news-archive.component.js